module.exports = __webpack_public_path__ + "static/media/endoscopia.41d5e2f9.png";